import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from '@bijie/react-bnb';
import { getLabel } from '../../utils/i18n';

const Box = styled.span.attrs(() => ({
  className: 'level-tip',
}))`
  display: inline-block;
  padding: 5px 8px;
  margin-right: 8px;
  line-height: 12px;
  color: '#F0B90B';
  border-radius: 2px;
  border: 1px solid currentColor;
  cursor: pointer;
`;
const NoTipBox = styled.span.attrs(() => ({
  className: 'level-tip',
}))`
  display: inline-block;
  height: 14px;
  padding: 2px;
  margin-left: 2px;
  color: #212833;
  background: #F0B90B;
  line-height: 12px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 2px;
`;

const mapStateToProps = ({ marginAccount: { marginBar, marginBarCustomed } }) => ({ marginBar, marginBarCustomed });

const MarginLevelBar = ({
  i18n, toggle, disable, marginBar, marginBarCustomed = true,
}) => {
  if (marginBarCustomed) return null;

  return disable ? <NoTipBox disable={true}>{marginBar}</NoTipBox>
    : (
      <Tooltip placement="top" trigger={['hover']} overlay={<span>{getLabel('exchange-bar-tip', i18n)}</span>}>
        <Box onClick={toggle}>{marginBar}</Box>
      </Tooltip>
    );
};
MarginLevelBar.propTypes = {
  i18n: PropTypes.object,
  toggle: PropTypes.func,
  disable: PropTypes.bool,
  marginBar: PropTypes.string,
  marginBarCustomed: PropTypes.bool,
};

export default connect(mapStateToProps)(MarginLevelBar);
